<template>
  <div class="questions">
    <div class="questions-item" v-for="(item, index) in QuestionList" :key="index">
      <div class="questions-item-question">
        <div class="questions-item-question-title">
          <z-icon name="n_v271d65358da8e44009440533ac5ffe9a5.png" size="16px" />
          <div class="questions-item-question-title-text">{{ item.question }}</div>
        </div>
        <z-icon v-show="false" name="arrow-down" size="14px" />
      </div>
      <div class="questions-item-answer">
        <div class="questions-item-answer-icon">
          <z-icon name="n_v2a7c78b05bb34471388c31c13643bea46.png" size="16px" />
        </div>
        <span class="questions-item-answer-text">{{ item.answer }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@zz-common/zz-ui'

const QuestionList = [
  {
    question: '所有欺诈举报成立后都能申请赔付么？',
    answer:
        '必须有转转订单且在全程在平台内沟通，平台中证据足以证明对方欺诈时，才可以申请赔付。所有站外证据不能够作为赔付依据。'
  },
  {
    question: '什么情况下需要提供派出所报案回执？',
    answer: '符合申请条件且案件金额在3000元以上的，在申请赔付时需提供派出所报案受理回执证明。'
  },
  {
    question: '为什么我的朋友无法领取放心转？',
    answer: '目前放心转仅对部分用户开放领取及赔付入口，今后将逐步向更多用户开放，敬请期待。'
  }
]

export default {
  name: 'QuestionList',
  data() {
    return {
      QuestionList
    }
  },
  components: {
    zIcon: Icon
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
